import { ApplicationSelection } from '../types/app-selection';

export enum StoreBrand {
    COUCHE_TARD = 'couche-tard',
    CIRCLE_K = 'circle-k',
}

export const STORE_BRAND_LABELS: Record<StoreBrand, string> = {
    [StoreBrand.COUCHE_TARD]: 'Couche-Tard',
    [StoreBrand.CIRCLE_K]: 'Circle K',
};

export const APPLICATION_TO_BRAND: Partial<Record<
    ApplicationSelection,
    StoreBrand
>> = {
    [ApplicationSelection.COUCHE_TARD]: StoreBrand.COUCHE_TARD,
    [ApplicationSelection.CIRCLE_K]: StoreBrand.CIRCLE_K,
};

export const BRAND_CSV_FILENAMES: Record<StoreBrand, string> = {
    [StoreBrand.COUCHE_TARD]: 'ct_stores.csv',
    [StoreBrand.CIRCLE_K]: 'ck_stores.csv',
};
